function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.87506 4.66643L4.37609 0.667607C4.18564 0.45117 3.81375 0.45117 3.62331 0.667607L0.124332 4.66643C0.0608474 4.7387 0.0195613 4.82774 0.00542662 4.92289C-0.00870806 5.01803 0.00490924 5.11523 0.0446445 5.20283C0.0843798 5.29043 0.148545 5.3647 0.229443 5.41673C0.31034 5.46877 0.404534 5.49636 0.500721 5.49619H2.50014V9.99487C2.50014 10.1274 2.5528 10.2546 2.64654 10.3483C2.74028 10.4421 2.86742 10.4947 2.99999 10.4947H4.9994C5.13197 10.4947 5.25911 10.4421 5.35285 10.3483C5.44659 10.2546 5.49926 10.1274 5.49926 9.99487V5.49619H7.49867C7.59495 5.49657 7.68929 5.46911 7.77032 5.41712C7.85135 5.36512 7.91563 5.29081 7.9554 5.20312C7.99517 5.11544 8.00875 5.01813 7.9945 4.92291C7.98024 4.82769 7.93877 4.73863 7.87506 4.66643Z"
});

function SvgIcSingleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSingleArrow);
export default ForwardRef;